export type AssetId = "sol" | "jto" | "kyros";
export type StakeMode = "restake" | "unstake";

export const ASSET_IDS: AssetId[] = ["sol", "jto", "kyros"];

export interface AssetReward {
  image: string;
  name: string;
  symbol: string;
  description: string;
}

export interface AssetConfig {
  id: AssetId;
  underlyingLabel: string;
  vrtName: string;
  mintAddress: string;
  vrtMintAddress: string;
  vaultAddress: string;
  vaultPaused: boolean;
  vaultMaxCap?: number;
  mintImage: string;
  vrtImage: string;
  headerImage: string;
  restakeDescription: string;
  unstakeDescription: string;
  marketingDescription: string;
  restakeStrategy: "sol" | "simple";
  rewards?: AssetReward[];
}

export const parseAssetId = (value: string | undefined): AssetId | null => {
  if (value && ASSET_IDS.includes(value as AssetId)) {
    return value as AssetId;
  }
  return null;
};

export const parseStakeMode = (value: string | null): StakeMode => {
  return value === "unstake" ? "unstake" : "restake";
};

export const LAST_STAKE_ASSET_KEY = "kyros_last_stake_asset";
